module.exports = __webpack_public_path__ + "img/navigation-brand.89da21fd.svg";